import type { JSX } from 'react';
import { HomeOutlined, SearchOutlined } from '@ant-design/icons';

import { Button } from '../components/ds';
import { openCmdK } from '../components/CmdKSearch';

/** 404 в оболочке HUB 2.0: иллюстрация, на главную или в поиск. */
export function NotFoundPage(): JSX.Element {
  return (
    <div className="fk-hub-404">
      <img src="/brand/illustrations/maki-character.png" alt="" />
      <h1>Такой страницы нет</h1>
      <p>Возможно, ссылка устарела или статью перенесли. Попробуйте найти нужное через поиск.</p>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginTop: 8 }}>
        <Button variant="primary" icon={<HomeOutlined />} to="/">
          На главную
        </Button>
        <Button variant="ghost" icon={<SearchOutlined />} onClick={() => openCmdK()}>
          Поиск
        </Button>
      </div>
    </div>
  );
}
